var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChubb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 1046.15 105.03",
    width: 1046.15,
    height: 105.03,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#fefefe;}.cls-2{fill:#1d1d1b;}"))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 21.39,25.9 c 0.38,17.49 0.32,35 0,52.48 -0.07,4.59 1.22,5.75 5.89,5.73 37.05,-0.19 74.1,0 111.15,-0.24 5.33,0 7.17,1.15 6.6,6.46 -0.52,4.84 -0.11,9.78 -0.11,14.68 -2.63,-2.92 -2.17,-6.53 -2.31,-10 -0.33,-8 -0.83,-8.68 -9.23,-8.71 -30.37,-0.1 -60.74,0 -91.12,0 -4.78,0 -9.56,0 -14.34,-0.11 -5.45,-0.16 -8.52,-2.59 -8.59,-8.1 -0.22,-17.5 -0.37,-35 0.08,-52.51 0.17,-6.38 2.29,-8 9.94,-8.11 17,-0.28 34,-0.08 50.94,-0.1 17.69,0 35.39,0.07 53.09,0 8.38,-0.06 8.8,-0.56 9.24,-8.72 0.16,-3 0,-6.11 2.3,-8.59 -0.11,6.26 2.25,14.65 -1,18.24 -3.75,4.17 -12.55,1.27 -19.14,1.3 -32.27,0.14 -64.54,0.2 -96.8,-0.07 -5.3,-0.11 -6.73,1.13 -6.59,6.37 z",
    id: "path6",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 204.66,95.77 c 0,3.25 0.15,6.58 -2.31,9.26 v -105 c 2.46,2.68 2.3,6 2.31,9.25 q 0.07,43.23 0,86.49 z",
    id: "path8",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 996.02,75.04 c -0.57,3.4 -0.14,7 -0.08,10.47 0.11,7.09 -3.2,11.92 -9.58,15.35 -3.82,2 -8.19,2 -12.06,3.56 0,0 0,0 0,0 a 3.67,3.67 0 0 0 -1.31,0.6 H 843.81 v -105 h 133.44 c 17.84,7.11 17.86,8.39 19,28.28 0.56,9.86 -4.46,14.65 -11.23,19.45 -4.17,3 -4.12,5.64 0.42,8.25 7.41,4.25 12.1,9.9 10.58,19.04 z",
    id: "path10",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 782.25,84.95 a 21.72,21.72 0 0 1 -5.36,12.15 c -4.36,5.06 -10.66,5.12 -16.11,7.24 v 0 a 2.75,2.75 0 0 0 -1.59,0.69 h -129.2 v -105 h 133.46 c 8.8,3.1 17.26,6.48 18.68,17.28 1.9,14.4 -0.52,26.84 -17.63,34.35 16.47,6.78 19.65,18.77 17.75,33.29 z",
    id: "path12",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 543.32,75.08 c -0.06,9.48 -1.7,11.14 -11.28,11.18 q -42.67,0.21 -85.36,0 c -9.58,0 -11.22,-1.7 -11.28,-11.18 -0.14,-22.16 -0.09,-44.33 0,-66.5 0,-3 0,-6.11 2.32,-8.58 0,26.13 0.12,52.26 -0.11,78.39 0,4.56 1.17,5.78 5.87,5.74 q 45.9,-0.32 91.8,0 c 4.7,0 5.91,-1.18 5.87,-5.74 -0.23,-26.13 -0.11,-52.26 -0.11,-78.39 2.29,2.47 2.31,5.55 2.32,8.58 0.05,22.17 0.1,44.32 -0.04,66.5 z",
    id: "path14",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 346.42,9.25 c 0,-3.24 -0.15,-6.57 2.31,-9.25 v 105 c -2.46,-2.68 -2.3,-6 -2.31,-9.26 q -0.07,-43.23 0,-86.49 z",
    id: "path16",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 439.13,105.03 c -3.38,-2.55 -7.88,-1.44 -11.5,-3.45 -8.75,-4.89 -11.29,-13 -11.37,-21.86 -0.24,-26.57 -0.09,-53.15 -0.09,-79.72 2.6,2.93 2.13,6.53 2.14,10 0.05,21.36 0,42.72 0,64.08 a 56.62,56.62 0 0 0 0.81,11.1 c 1.57,8 5.92,13.47 14.14,15.87 2.31,0.63 5.54,0.44 5.87,3.98 z",
    id: "path18",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 562.55,0 v 79.36 c 0,15.94 -5.46,22.07 -21.61,24.39 -0.51,0.07 -0.91,0.84 -1.35,1.28 0.19,-3.24 3.09,-3.12 5.17,-3.84 11.57,-4 15.47,-9 15.56,-21.29 0.18,-23.3 0,-46.6 0.08,-69.89 0.01,-3.46 -0.46,-7.06 2.15,-10.01 z",
    id: "path20",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 145.06,90.35 c -0.52,4.84 -0.11,9.78 -0.11,14.68 h -122 a 5.71,5.71 0 0 0 -3.68,-0.78 v 0 C 10.9,102.15 4.07,97.84 0,89.63 V 15.4 C 3.75,7.4 10.1,2.4 18.66,0 h 126.29 c -0.11,6.26 2.25,14.65 -1,18.24 -3.75,4.17 -12.55,1.27 -19.14,1.3 -32.27,0.14 -64.54,0.2 -96.8,-0.07 -5.35,-0.05 -6.75,1.19 -6.64,6.45 0.38,17.49 0.32,35 0,52.48 -0.07,4.59 1.22,5.75 5.89,5.73 37.05,-0.19 74.1,0 111.15,-0.24 5.38,0.01 7.22,1.15 6.65,6.46 z",
    id: "path22",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 562.55,0 v 79.36 c 0,15.94 -5.46,22.07 -21.61,24.39 -0.51,0.07 -0.91,0.84 -1.35,1.28 H 439.13 c -3.38,-2.55 -7.88,-1.44 -11.5,-3.45 -8.75,-4.89 -11.29,-13 -11.37,-21.86 C 416.02,53.15 416.17,26.57 416.17,0 h 21.53 c 0,26.13 0.12,52.26 -0.11,78.39 0,4.56 1.17,5.78 5.87,5.74 q 45.9,-0.32 91.8,0 c 4.7,0 5.91,-1.18 5.87,-5.74 C 540.9,52.26 541.02,26.13 541.02,0 Z",
    id: "path24",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 348.73,0 v 105 h -20.09 c 0,-12.83 -0.16,-25.66 0.09,-38.49 0.08,-4 -1.1,-5 -5.14,-5 q -48,0.24 -96.1,0 c -4,0 -5.22,1 -5.14,5 0.25,12.83 0.09,25.66 0.09,38.49 H 202.35 V 0 h 20.09 c 0,12.36 0.17,24.73 -0.09,37.09 -0.08,4 1.1,5 5.14,5 q 48,-0.24 96.1,0 c 4,0 5.22,-1.05 5.14,-5 C 328.47,24.73 328.64,12.36 328.64,0 Z",
    id: "path26",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 1046.15,19.6 c -6.72,9.7 -13.6,12.19 -22.14,8.23 -5,-2.34 -7.94,-5.69 -8.08,-11.46 -0.17,-6.35 0.8,-11.76 7.55,-14.57 0.94,-0.4 2.44,-0.24 2.58,-1.8 0.57,2.44 -1.62,3 -3,4.16 -5.86,4.79 -7.12,14 -2.57,19 5.15,5.66 14.55,5.77 20.4,0.36 1.62,-1.46 2.14,-4.37 5.26,-3.92 z",
    id: "path28",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 1046.15,9.8 v 9.8 c -6.72,9.7 -13.6,12.19 -22.14,8.23 -5,-2.34 -7.94,-5.69 -8.08,-11.46 -0.17,-6.35 0.8,-11.76 7.55,-14.57 0.94,-0.4 2.44,-0.24 2.58,-1.8 h 10 q 8.65,1.41 10.09,9.8 z",
    id: "path30",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 1046.15,9.8 a 25.12,25.12 0 0 0 -10,-9.8 c 10,0 10,0 10,9.8 z",
    id: "path32",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 919.46,85.42 c -16.25,0 -32.5,-0.17 -48.75,0.12 -4.5,0.08 -5.9,-1.14 -5.43,-5.43 0.64,-6 -2.52,-13.67 1.22,-17.48 3.43,-3.5 11.31,-1 17.22,-1 28.19,-0.1 56.4,0.09 84.59,-0.17 5.09,-0.05 6.75,1.25 6.16,6.14 -0.69,5.72 2.49,13.29 -1.19,16.77 -3.68,3.48 -11.34,0.91 -17.25,1 -12.19,0.16 -24.38,0.05 -36.57,0.05 z",
    id: "path34",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 920.59,19.6 c 16.25,0 32.5,0.13 48.75,-0.09 4,-0.05 5.12,1 5.17,5 0.23,17.5 0.38,17.5 -17.36,17.5 -28.68,0 -57.36,-0.11 -86,0.11 -4.66,0 -5.93,-1.13 -5.9,-5.72 0.09,-16.8 -0.1,-16.8 17.38,-16.8 z",
    id: "path36",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 706.77,61.62 c 16.25,0 32.51,0.12 48.75,-0.09 4,-0.06 5.42,1 5.14,5 -0.42,6 2,13.86 -1.06,17.58 -3.22,3.91 -11.6,1.22 -17.71,1.25 -28.2,0.12 -56.4,-0.06 -84.6,0.16 -4.66,0 -6.26,-1.11 -5.86,-5.73 0.49,-5.76 -2,-13.54 1,-16.87 3.49,-3.88 11.63,-1.17 17.74,-1.26 12.23,-0.17 24.42,-0.04 36.6,-0.04 z",
    id: "path38",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 706.03,19.6 c 16.49,0 33,0.13 49.46,-0.08 4,-0.06 5.15,1 5.2,5 0.24,17.52 0.39,17.52 -17.34,17.52 -28.67,0 -57.35,-0.1 -86,0.1 -4.6,0 -6,-1 -5.93,-5.69 0.1,-16.82 -0.1,-16.82 17.36,-16.82 z",
    id: "path40",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 1024.25,23.45 c -5.91,-5 -5.88,-12.57 0,-17.49 z",
    id: "path42",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 1038.55,7.69 c 4.75,1.82 3.2,6.23 3.21,9.95 0,1.95 -1.12,3.8 -3.52,3 -2.12,-0.72 -3.22,-4.49 -2.77,-4.68 4.45,-1.87 0.42,-5.74 3.08,-8.27 z",
    id: "path44",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 1030.68,16.25 c 1.26,3.38 5.55,5.32 4.28,8.5 -0.58,1.45 -5.46,2.41 -7.9,-0.75 3.96,-1.23 0.33,-5.17 3.62,-7.75 z",
    id: "path46",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 1034.73,11.18 c -2.15,1.4 -4.2,2.45 -5.65,0.14 -0.35,-0.58 0,-2.35 0.46,-2.51 2.33,-0.81 3.31,1.59 5.19,2.37 z",
    id: "path48",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 1026,5.25 c 3.74,-2.11 6.56,-1.89 10.65,0 z",
    id: "path50",
    style: {
      fill: "#fefefe"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChubb);
export default __webpack_public_path__ + "static/media/chubb.ebd5acd273273fe03be55526e4d7987e.svg";
export { ForwardRef as ReactComponent };